import React from 'react';
import { Switch as AntdSwitch } from 'antd';
import classes from './Switch.module.scss';

export const Switch = (props) => {
  const { field, value } = props;
  const { switchProps = {}, disabled } = field;
  const { label, ...rest } = switchProps;
  return (
    <span className={classes.switch}>
      <AntdSwitch checked={value} disabled={disabled} {...rest} />
      <span className="switch-label">{label}</span>
    </span>
  );
};
